import React from 'react';
import { inputStyles } from '../Input';

export default function ErrorWrapper(props: Component.DefaultProps & { style?: React.CSSProperties; id?: string }) {
  return (
    <div id={props.id} className={inputStyles.wrapper.errorWrapper} children={props.children} style={props.style} />
  );
}
